module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Acknowledgements"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('b', [_vm._v("Author’s Note and Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In general it has been found practical to use footnotes largely to identify the sources of quotations; further references appear in the bibliography.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("The author extends especial thanks to: Derek Green, Dr John A. Hall, Alan Harrison, and Dennis Sully.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a290636","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknowledgements.vue
// module id = 66
// module chunks = 0